import { render, staticRenderFns } from "./SocialServe.vue?vue&type=template&id=5ea64224&scoped=true&"
import script from "./SocialServe.vue?vue&type=script&lang=js&"
export * from "./SocialServe.vue?vue&type=script&lang=js&"
import style0 from "./SocialServe.vue?vue&type=style&index=0&id=5ea64224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea64224",
  null
  
)

export default component.exports